// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../Config.bs.js";

var partnerScoreRequestUrl = Config.Env.getPartnerAppGatewayUrl(undefined) + "/supply_management/performance_score";

export {
  partnerScoreRequestUrl ,
  
}
/* partnerScoreRequestUrl Not a pure module */
